import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { getUserDetail } from "../api/userApi";
import { showError } from "../utils/alert";
import { formatDateTime } from "../utils/dateFormat";

export default function UserDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await getUserDetail(id);
        setData(res.data);
      } catch (err) {
        showError("Failed to load user detail");
        navigate("/users");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id, navigate]);

  const user = data?.user;
  const prof = data?.professional_detail;
  const events = data?.events || [];
  const formatActive = (v) => (v === "1" ? "Active" : "Inactive");
  const statusLabel = user ? formatActive(user.status) : "";

  return (
    <AdminLayout title="User Detail">
      {loading && <p>Loading...</p>}
      {!loading && user && (
        <>
          <div className="row g-4 mb-4">
            <div className="col-md-6">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <h5 className="card-title mb-3">User Info</h5>
                  <dl className="row mb-0 small">
                    <dt className="col-sm-4">Name</dt>
                    <dd className="col-sm-8">
                      {user.first_name} {user.last_name}
                    </dd>
                    <dt className="col-sm-4">Email</dt>
                    <dd className="col-sm-8">{user.email}</dd>
                    <dt className="col-sm-4">Mobile</dt>
                    <dd className="col-sm-8">{user.mobile || "-"}</dd>
                    <dt className="col-sm-4">Status</dt>
                    <dd className="col-sm-8">{statusLabel}</dd>
                    <dt className="col-sm-4">Email verified</dt>
                    <dd className="col-sm-8">{formatActive(user.is_email_verified)}</dd>
                    <dt className="col-sm-4">Address</dt>
                    <dd className="col-sm-8">{user.address || "-"}</dd>
                  </dl>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <h5 className="card-title mb-3">Professional Profile</h5>
                  {!prof && (
                    <p className="text-muted small mb-0">
                      No professional profile.
                    </p>
                  )}
                  {prof && (
                    <dl className="row mb-0 small">
                      
                      <dt className="col-sm-4">Seat</dt>
                      <dd className="col-sm-8">{prof.seat_title || "-"}</dd>
                      <dt className="col-sm-4">Airline</dt>
                      <dd className="col-sm-8">{prof.airline_title || "-"}</dd>
                      <dt className="col-sm-4">Base</dt>
                      <dd className="col-sm-8">{prof.base_title || "-"}</dd>
                      <dt className="col-sm-4">Aircraft</dt>
                      <dd className="col-sm-8">{prof.aircraft_title || "-"}</dd>
                      <dt className="col-sm-4">Role</dt>
                      <dd className="col-sm-8">{prof.role_title || "-"}</dd>
                      <dt className="col-sm-4">Calendar</dt>
                      <dd className="col-sm-8">{prof.calendar_title || "-"}</dd>
                      <dt className="col-sm-4">Permission</dt>
                      <dd className="col-sm-8">
                        {prof.permission ? "Yes" : "No"}
                      </dd>
                    </dl>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="card shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="card-title mb-0">Events</h5>
              </div>
              <div className="table-responsive">
                <table className="table table-striped table-hover align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Summary</th>
                      <th>Start</th>
                      <th>End</th>
                      <th>Calendar</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {events.length === 0 && (
                      <tr>
                        <td colSpan="5" className="text-center text-muted">
                          No events found.
                        </td>
                      </tr>
                    )}
                    {events.map((e) => (
                      <tr key={e.id}>
                        <td>{e.summary}</td>
                        <td>{formatDateTime(e.start)}</td>
                        <td>{formatDateTime(e.end)}</td>
                        <td>
                          <span
                            className="badge"
                            style={
                              e.calendar_color
                                ? {
                                    backgroundColor: e.calendar_color,
                                    color: "#fff",
                                  }
                                : undefined
                            }
                          >
                            {e.calendar_name || "-"}
                          </span>
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() =>
                              navigate(`/events/detail/${e.id}`, {
                                state: { fromUserDetail: true, userId: id },
                              })
                            }
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
    </AdminLayout>
  );
}

